import React from "react";
import { Button } from 'react-vant';
import 'animate.css';
import './whatsapp.scss'
import "../../chat/animate/slide_in_left.css";
import whatsApp from '../../../assets/update_new/whatsapp_logo_green.svg'
const WhatsApp = ({ avator, content, whatsAppClick }) => {
    
    return (
        <div className="ai_content_whatsApp slide-in-left">
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <img src={avator} className="ai_avatar" />
                <div className={`ai_content_message`} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <img src={whatsApp} className="ai_whatsApp" alt="whatsapp" />
                    <span className="ai_whatsApp_content" style={{ marginTop: '15px', marginBottom: '15px', textAlign: 'center' }}>{content}</span>
                    <Button color='#FFB341' type='primary' block className="whatsApp_cofirm" onClick={whatsAppClick}>
                        Continue
                    </Button>
                </div>
            </div>
        </div>
    )
}
export default WhatsApp;